import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import AppErrorBoundary from "./components/feature/AppErrorBoundary";
import EngineBootstrapper from "./components/feature/EngineBootstrapper";

function App() {
  return (
    <AppErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <EngineBootstrapper />
          <AppRoutes />
        </BrowserRouter>
      </I18nextProvider>
    </AppErrorBoundary>
  );
}

export default App;